module.exports = __webpack_public_path__ + "img/compare.0cfd7add.png";